import { Observable, type Observer } from 'rxjs';

// Assumes requestIdleCallback/cancelIdleCallback are polyfilled at app bootstrap (Safari/WebKit
// never implemented them) — see @bcf2-polyfills / @bcflit-polyfills.
export function browserIdle(windowAsAny: Window): Observable<void> {
  return new Observable<void>((observer: Observer<void>) => {
    const handle: any = windowAsAny.requestIdleCallback(() => {
      observer.next(undefined);
      observer.complete();
    });
    return (): void => windowAsAny.cancelIdleCallback(handle);
  });
}
